import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import ModalComponent from '../modals/ModalComponent';
import PdfPreviewer from '../pdf/ShowPdf';
import Schema from '../../classes/index';
import { GET_PREVIEW_PDF } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import Alerts from '../alerts/Alerts';
import PropTypes from 'prop-types';

const ModalPreview = ({
  previewData,
  getPreview,
  contractPdf,
  globalSpin
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const buttonOnClick = () => {
    setModalVisible(true);
    getPreview(Schema.rentContract.preview(previewData));
  };

  return (
    <>
      {modalVisible &&
        <ModalComponent
          title='Previsualización de contrato'
          modalVisible={modalVisible}
          spinning={globalSpin}
          onCancel={() => setModalVisible(false)}
          bodyStyle={{
            height: 700,
            'overflowY': 'scroll'
          }}
          width={'60%'}
          content={
            <>
              <Alerts />
              <PdfPreviewer pdf={contractPdf} />
            </>
          }
          footer={null}
          maskClosable={true}
        />
      }
      <Button size={'large'} onClick={buttonOnClick}>
        Ver contrato
      </Button>
    </>
  );
};

ModalPreview.propTypes = {
  contractPdf: PropTypes.string,
  previewData: PropTypes.object,
  getPreview: PropTypes.func,
  globalSpin: PropTypes.bool,
};

const data = (state) => ({
  previewData: state.contract.previewData,
  contractPdf: state.contract.contractPdf,
  globalSpin: state.download.globalSpin
});

const actions = (dispatch) => ({
  getPreview: payload => dispatch({ type: GET_PREVIEW_PDF, payload: { payload, resource: RESOURCE.GET_PREVIEW_PDF } }),
});

export default connect(data, actions)(ModalPreview);
